var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 0.333252C14.7661 0.33525 14.86 0.35336 14.9539 0.397998C15.0507 0.444295 15.1359 0.514051 15.2003 0.599919C15.2426 0.662847 15.2327 0.643963 15.2003 0.599919C15.2867 0.715053 15.3337 0.856034 15.3337 0.999919C15.3334 0.964408 15.3319 0.948996 15.3337 0.999919V10.9999C15.3337 11.3681 15.0352 11.6666 14.667 11.6666H1.33366C0.965469 11.6666 0.666992 11.3681 0.666992 10.9999V0.999919C0.666992 0.880567 0.69937 0.762057 0.760275 0.659698C0.884388 0.450572 1.09936 0.337976 1.33366 0.333252H14.667ZM14.0003 2.33325L8.40033 6.53325C8.18699 6.69325 7.90166 6.70925 7.67392 6.58125L7.60032 6.53325L2.00033 2.33325V10.3333H14.0003V2.33325ZM3.33366 1.66659L8.00033 5.16659L12.667 1.66659H3.33366Z",
    fill: "#FAAD14"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9fb724c312868cca3fcabd0718775fa1.svg";
export { ForwardRef as ReactComponent };